<!-- PC端企业微信打开展示微信用户名 -->
<template>
  <span @click="$emit('click')">
    <span v-if="!wxConfigStore.wxready">{{ openid }}</span>
	  <span v-else ><ww-open-data ref="open_date" type="userName" :openid="openid" /></span>
  </span>

</template>
<script>
import { useWxConfigStore } from '@/stores/wx'
export default {
  props: {
    openid: {
      type: String,
      requiered: true
    }
  },
  data() {
    return {
      wxConfigStore: useWxConfigStore()
    }
  },
  watch: {
    // 监听微信配置变化
    'wxConfigStore.wxready': {
      handler(newVal) {
        if(newVal) window.WWOpenData.bind(this.$refs.open_date)
      },
      immediate: true
    }
  },
}

</script>
<style scoped></style>
